import { ProjectStatus } from "@/models/project-status.model";
import { SeverityService } from "@/services/app/severity.service";
import { Component, inject, Input } from "@angular/core";
import { TagModule } from "primeng/tag";


@Component({
    selector: 'app-status-column',
    template: `
    <p-tag [value]="value?.Status"
                [severity]="getSeverity(value?.StatusID)"></p-tag>
    `,
    standalone: true,
    imports: [
        TagModule
    ],
    styles: [
        `
        `
    ]
})

export class StatusColumnComponent {
@Input() value: ProjectStatus | null = null;
statusService = inject(SeverityService);

getSeverity(statusId: number | undefined): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined {
 return this.statusService.getSeverity(statusId);
  }
}